<ng-container *transloco="let t;">
<form (submit)="onSubmit()" novalidate>

    <div class="p-grid">
        <div class="p-col-6">
            <h2>{{ t('common.labels.basedata') }}</h2>
        </div>
        <div class="p-col-6 p-text-right">
          <app-form-buttons [submitting]="submitting" (cancelled)="onCancel()"></app-form-buttons>
        </div>
    </div>


    <div class="p-grid p-fluid">
        <div class="p-col-12 p-md-6">

          <app-form-control [cid]="'name_de'" [control]="form.get('name_de')" [type]="'input'" [label]="t('common.labels.name_de')"></app-form-control>
          <app-form-control [cid]="'name_en'" [control]="form.get('name_en')" [type]="'input'" [label]="t('common.labels.name_en')"></app-form-control>
          <app-form-control [cid]="'legend_de'" [control]="form.get('legend_de')" [type]="'textarea'" [label]="t('common.labels.legend_de')"></app-form-control>
          <app-form-control [cid]="'legend_en'" [control]="form.get('legend_en')" [type]="'textarea'" [label]="t('common.labels.legend_en')"></app-form-control>

        </div>
        <div class="p-col-12 p-md-6">

          <app-form-control [cid]="'min_value'" [control]="form.get('min_value')" [type]="'input'" [label]="t('common.labels.min_value')"></app-form-control>
          <app-form-control [cid]="'max_value'" [control]="form.get('max_value')" [type]="'input'" [label]="t('common.labels.max_value')"></app-form-control>
          <app-form-control [cid]="'step'" [control]="form.get('step')" [type]="'slider'" [label]="t('common.labels.step')" [min]="0.5" [max]="10" [step]="0.5"></app-form-control>

          <app-form-error *ngIf="form.errors?.minMax" [control]="form" [inline]="true"></app-form-error>

        </div>
    </div>


</form>
</ng-container>
